var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyDocs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 160,
    viewBox: "0 0 241 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "474 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M99.1266 46H70.7937C46.0548 46 26 66.0548 26 90.7935C26 115.532 46.0548 135.587 70.7937 135.587H99.1266C123.866 135.587 143.92 115.532 143.92 90.7935C143.92 66.0548 123.866 46 99.1266 46Z",
    fill: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.93 36.6734L93.2248 25.376C91.9969 24.6342 90.635 24.1415 89.2167 23.9261C87.7985 23.7107 86.3516 23.7768 84.9589 24.1207L46.9355 33.5263C41.0773 34.9754 37.5071 40.8983 38.9576 46.7619L57.3339 121.051C58.7844 126.914 64.7041 130.489 70.5623 129.04L123.579 115.926C129.437 114.477 133.007 108.554 131.557 102.691L116.892 43.4081C116.196 40.5944 114.411 38.1722 111.93 36.6734Z",
    fill: "#FDFDFD",
    stroke: "#D9D8DF",
    strokeWidth: 0.884703
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M109.93 87.5516L69.6941 97.5044C68.2127 97.8709 67.3088 99.3689 67.6753 100.85C68.0417 102.332 69.5397 103.236 71.0212 102.869L111.257 92.9164C112.738 92.5499 113.642 91.0519 113.276 89.5705C112.909 88.089 111.411 87.1851 109.93 87.5516Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M107.297 76.8992L67.0613 86.8521C65.5799 87.2186 64.676 88.7166 65.0424 90.198C65.4089 91.6795 66.9069 92.5834 68.3884 92.2169L108.624 82.264C110.105 81.8976 111.009 80.3996 110.643 78.9181C110.276 77.4366 108.778 76.5328 107.297 76.8992Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M104.656 66.2234L64.4207 76.1763C62.9392 76.5428 62.0354 78.0408 62.4018 79.5223C62.7683 81.0037 64.2663 81.9076 65.7477 81.5411L105.983 71.5883C107.465 71.2218 108.369 69.7238 108.002 68.2423C107.636 66.7609 106.138 65.857 104.656 66.2234Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M102.016 55.5477L61.7801 65.5005C60.2986 65.867 59.3947 67.365 59.7612 68.8465C60.1276 70.3279 61.6257 71.2318 63.1071 70.8653L103.343 60.9125C104.824 60.546 105.728 59.048 105.362 57.5665C104.995 56.0851 103.497 55.1812 102.016 55.5477Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M99.3751 44.868L59.1394 54.8208C57.658 55.1873 56.7541 56.6853 57.1206 58.1668C57.487 59.6482 58.9851 60.5521 60.4665 60.1857L100.702 50.2328C102.184 49.8663 103.087 48.3683 102.721 46.8869C102.355 45.4054 100.857 44.5015 99.3751 44.868Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M112.586 98.282L72.3504 108.235C70.8689 108.601 69.965 110.099 70.3315 111.581C70.698 113.062 72.196 113.966 73.6774 113.6L113.913 103.647C115.395 103.28 116.298 101.782 115.932 100.301C115.565 98.8195 114.067 97.9156 112.586 98.282Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.437 42.0723L157.293 26.3185C156.299 25.2842 155.111 24.4559 153.797 23.8808C152.482 23.3057 151.068 22.9952 149.634 22.9669L110.472 22.2108C104.438 22.0943 99.4564 26.8912 99.3398 32.9303L97.8627 109.444C97.7461 115.483 102.539 120.469 108.573 120.585L163.177 121.639C169.21 121.756 174.192 116.959 174.308 110.92L175.487 49.862C175.542 46.9638 174.445 44.1622 172.437 42.0723Z",
    fill: "#FDFDFD",
    stroke: "#D9D8DF",
    strokeWidth: 0.884703
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M157.344 90.701L115.903 89.901C114.378 89.8715 113.117 91.0846 113.087 92.6104C113.058 94.1362 114.271 95.397 115.797 95.4265L157.237 96.2265C158.763 96.256 160.024 95.0429 160.053 93.5171C160.083 91.9913 158.87 90.7305 157.344 90.701Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M157.555 79.7284L116.114 78.9283C114.588 78.8989 113.328 80.1119 113.298 81.6377C113.269 83.1636 114.482 84.4244 116.008 84.4538L157.448 85.2538C158.974 85.2833 160.235 84.0703 160.264 82.5444C160.294 81.0186 159.081 79.7578 157.555 79.7284Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M157.766 68.7284L116.325 67.9283C114.799 67.8989 113.539 69.1119 113.509 70.6377C113.48 72.1636 114.693 73.4244 116.219 73.4538L157.659 74.2538C159.185 74.2833 160.446 73.0703 160.475 71.5444C160.505 70.0186 159.292 68.7578 157.766 68.7284Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M157.981 57.7362L116.54 56.9361C115.014 56.9067 113.753 58.1197 113.724 59.6456C113.695 61.1714 114.908 62.4322 116.433 62.4616L157.874 63.2617C159.4 63.2911 160.661 62.0781 160.69 60.5522C160.72 59.0264 159.507 57.7656 157.981 57.7362Z",
    fill: "#006546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M158.192 46.7401L116.751 45.9401C115.225 45.9106 113.964 47.1236 113.935 48.6495C113.905 50.1753 115.119 51.4361 116.644 51.4655L158.085 52.2656C159.611 52.295 160.872 51.082 160.901 49.5562C160.931 48.0303 159.717 46.7695 158.192 46.7401Z",
    fill: "#006546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M157.129 101.748L115.689 100.948C114.163 100.918 112.902 102.131 112.872 103.657C112.843 105.183 114.056 106.444 115.582 106.473L157.022 107.273C158.548 107.303 159.809 106.09 159.839 104.564C159.868 103.038 158.655 101.777 157.129 101.748Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M200.985 133.063L195.273 127.34M179.279 129.629C189.374 129.629 197.558 121.429 197.558 111.314C197.558 101.2 189.374 93 179.279 93C169.184 93 161 101.2 161 111.314C161 121.429 169.184 129.629 179.279 129.629Z",
    stroke: "#D9D8DF",
    strokeWidth: 9.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDocs);
export default __webpack_public_path__ + "static/media/empty-docs.76150e02687d9c60651afb4c5c68cd4c.svg";
export { ForwardRef as ReactComponent };